import client from '../client'

export const getUserNotificationsKey = `${process.env.NEXT_PUBLIC_NOTIFICATIONS_DOMAIN}/api/UserNotifications/GetUserNotifications`

export async function getUserNotifications() {
  return client(getUserNotificationsKey)
}
